import { Link } from 'react-router-dom';
import { getFeaturedComic, getHotComics } from '@/mocks/comics';

export default function FeaturedSection() {
  const featured = getFeaturedComic();
  const hotComics = getHotComics().filter((c) => c.slug !== featured?.slug).slice(0, 2);

  if (!featured) return null;

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-medium text-accent-600 tracking-widest uppercase">
            编辑精选
          </span>
          <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            今日<span className="text-accent-600">推荐</span>
          </h3>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 md:gap-6">
          <Link
            to={`/comic/${featured.slug}`}
            className="lg:w-1/2 relative group rounded-2xl overflow-hidden cursor-pointer"
          >
            <div className="aspect-[3/4] md:aspect-[4/3] lg:aspect-[3/4] w-full relative">
              <img
                src={featured.coverImage}
                alt={featured.title}
                title={`${featured.title} - 洞洞杂货铺高清漫画全集免费阅读下拉式`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium mb-3">
                  {featured.category}
                </span>
                <h4 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2">
                  {featured.title}
                </h4>
                <p className="text-white/70 text-sm line-clamp-2 max-w-md">
                  {featured.description}
                </p>
                <div className="flex items-center gap-4 mt-3 text-white/60 text-xs">
                  <span>⭐ {featured.rating}</span>
                  <span>{featured.totalChapters}话</span>
                  <span>{(featured.reads / 10000).toFixed(0)}万阅读</span>
                </div>
              </div>
            </div>
          </Link>

          <div className="lg:w-1/2 flex flex-col gap-5 md:gap-6">
            {hotComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="group relative rounded-2xl overflow-hidden cursor-pointer flex-1 min-h-[160px] md:min-h-[200px]"
              >
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title}高清漫画全集免费阅读下拉式 - 178漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent" />
                <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-medium mb-2 w-fit">
                    {comic.category}
                  </span>
                  <h4 className="font-heading text-xl md:text-2xl font-bold text-white">
                    {comic.title}
                  </h4>
                  <p className="text-white/60 text-xs mt-1">
                    {comic.author} · {comic.rating}分 · {comic.totalChapters}话
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}